import { CustomerLayout } from "@/components/CustomerLayout/CustomerLayout";
import { DocumentError } from "@/components/DocumentError/DocumentError";
import { DocumentHjemmelserklaering } from "@/components/DocumentHjemmelserklaering/DocumentHjemmelserklaering";
import { routeLoaderApiClient } from "@/lib/api";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute(
  "/_authenticated-user/oppdrag/$tluxCaseId/hjemmelserklæring/$hjemmelserklaeringId/",
)({
  loader: async ({ params }) => {
    const { tluxCaseId, hjemmelserklaeringId: hjemmelserklæringId } = params;

    const res = await routeLoaderApiClient.oppdrag[":tluxCaseId"].hjemmelserklæring[":hjemmelserklæringId"].$get({
      param: {
        tluxCaseId,
        hjemmelserklæringId,
      },
    });

    if (res.ok === false) {
      throw new Error("Failed to fetch sletting");
    }

    return {
      response: await res.json(),
    };
  },
  head: () => ({
    meta: [{ title: "Rediger hjemmelserklæring | Alice & Bob" }],
  }),
  component: Page,
});

function Page() {
  const { tluxCaseId, hjemmelserklaeringId: hjemmelserklæringId } = Route.useParams();
  const { response } = Route.useLoaderData();

  const oppdragUrl = `/oppdrag/${tluxCaseId}`;

  if (response.status === "error") {
    return (
      <CustomerLayout>
        <DocumentError tluxCaseId={tluxCaseId} message={response.message} />
      </CustomerLayout>
    );
  }

  return (
    <CustomerLayout>
      <DocumentHjemmelserklaering
        tluxCaseId={tluxCaseId}
        hjemmelserklæringId={hjemmelserklæringId}
        hjemmelserklæring={response.hjemmelserklæring}
        cancelUrl={oppdragUrl}
      />
    </CustomerLayout>
  );
}
